var _rect, _g, _rect2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 30,
    fill: "url(#paint0_linear_24_21)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_24_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.0655,
    y: 50,
    width: 68.1223,
    height: 42.5764,
    rx: 21.2882,
    fill: "url(#paint1_linear_24_21)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.9999,
    width: 73.7991,
    height: 73.7991,
    rx: 30,
    fill: "url(#paint2_linear_24_21)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_24_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6979 67.6564V42.9229H30.4841V67.6564H38.6987H38.6979ZM34.5927 39.5466C37.4564 39.5466 39.2393 37.6473 39.2393 35.2738C39.1857 32.8462 37.4564 31 34.6472 31C31.836 31 30 32.8462 30 35.2736C30 37.6471 31.7822 39.5464 34.5389 39.5464H34.5921L34.5927 39.5466ZM43.2443 67.6564H51.4574V53.8456C51.4574 53.1074 51.511 52.3672 51.728 51.8399C52.3215 50.3624 53.6729 48.8329 55.9425 48.8329C58.9138 48.8329 60.1031 51.1008 60.1031 54.4261V67.6564H68.316V53.475C68.316 45.8782 64.2645 42.3431 58.8606 42.3431C54.4302 42.3431 52.4844 44.8215 51.4033 46.5096H51.458V42.9238H43.2447C43.3519 45.2441 43.2441 67.6573 43.2441 67.6573L43.2443 67.6564Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_24_21",
    x: 9.60549,
    y: 44.54,
    width: 79.0423,
    height: 53.4964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_24_21"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_24_21",
    x: 27,
    y: 27,
    width: 45,
    height: 45.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_21",
    x1: 8.40611,
    y1: 6.55022,
    x2: 82.6419,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_21",
    x1: 53.8347,
    y1: 93.8462,
    x2: 39.9491,
    y2: 44.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058CCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_21",
    x1: 55,
    y1: 88.9999,
    x2: 20.5,
    y2: 12.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058CCF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.daf0e2d6034c73ba1eca10ae881ccbf0.svg";
export { ForwardRef as ReactComponent };